module.exports = __webpack_public_path__ + "fonts/tficonfont.e8cd5a75.ttf";